import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Link from "next/link";
import Colors from "../utils/Colors";
import HomeIcon from "./icons/nav/HomeIcon";
import SearchIcon from "./icons/nav/SearchIcon";
import OrdersIcon from "./icons/nav/OrdersIcon";
import SupportIcon from "./icons/nav/SupportIcon";
import ProfileIcon from "./icons/nav/ProfileIcon";

export const NAV_HEIGHT = 49;

const DEFAULT_ITEMS = [
  {
    key: "home",
    label: "メニュー",
    icon: HomeIcon,
    path: "/test/one",
  },
  {
    hideOnDesktop: true,
    key: "search",
    label: "探す",
    icon: SearchIcon,
    path: "/test/two",
  },
  {
    key: "orders",
    label: "履歴",
    icon: OrdersIcon,
    path: "/orders",
  },
  {
    key: "support",
    label: "メッセージ",
    icon: SupportIcon,
    path: "/support",
  },
  {
    key: "profile",
    label: "マイページ",
    icon: ProfileIcon,
    path: "/profile",
  },
];

const useStyles = createUseStyles((theme) => ({
  container: {
    zIndex: 10,
    height: NAV_HEIGHT,
    display: "flex",
    "-webkit-font-smoothing": "antialiased",
  },
  item: {
    flex: 1,
    textAlign: "center",
    paddingTop: theme.spacing.unit,
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: 8,
    left: "calc(50% - 12px)",
    height: 24,
    width: 24,
  },
  text: {
    position: "absolute",
    top: 35,
    left: 0,
    right: 0,
    fontWeight: "700",
    fontSize: "8px",
    lineHeight: "12px",
    color: theme.primaryGray,
    userSelect: "none",
    letterSpacing: 0,
    fontFamily: `-apple-system, 'Helvetica Neue', 'Helvetica', 'Arial', 'Lucida Grande', sans-serif`,
    "-webkit-font-smoothing": "antialiased",
    "-webkit-tap-highlight-color": "transparent",
  },
  textSelected: {
    color: theme.primaryPink,
  },
}));

export default ({
  selectedKey = "home",
  items = DEFAULT_ITEMS,
  classes: overrideClasses,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, overrideClasses?.root)}>
      {items.map((item) => {
        const isSelected = item.key === selectedKey;

        return (
          <Link key={item.path} href={item.path}>
            <div className={classNames(classes.item, overrideClasses?.item)}>
              {item.icon && (
                <item.icon
                  color={isSelected ? Colors.primaryPink : Colors.primaryGray}
                  className={classes.icon}
                />
              )}
              <div
                className={classNames(classes.text, {
                  [classes.textSelected]: isSelected,
                })}
              >
                {item.label}
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};
